
import axios from 'axios';
import _ from 'lodash';
import {CircularProgress, FormControl, FormHelperText} from '@material-ui/core';

import React, { Component}  from 'react';
import { FormContext } from 'core/FormProvider';
import { AsyncSelectWidget } from 'form/SelectAsync';
import TextField from '@material-ui/core/TextField';
import { ContextWidget, ContextFormControlWidget } from 'form/Contexed';
import { CheckboxWidget } from 'form/Checkbox';
import { InputWidget } from 'form/InputWidget';
import FormGroup from 'form/FormGroup';
import { TariffPointForm } from './FormPoints';
import {YellowButton} from 'ui/Button';
import Fuse from 'fuse.js';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import VatWidget from "form/VatWidget";
import TariffServicesForm from "./FormServices";
import qs from "qs";
import AddPointDrawer from "./AddPointDrawer";


export class TariffBaseForm extends Component {

  static contextType = FormContext;

  constructor(props) {
    super(props);

    this.state = {
      loadingPoints: true,
      points: [],
      search: '',
      searchedPoints: []
    }
  }

  componentDidMount() {
    this.loadAllOptions();
  }

  loadAllOptions = async () => {
    let points = [];
    const { item } = this.props.formContext;
    const pointsId = item.tariff_points.map(item => item.point);
    if (pointsId.length > 0) {
      const params = {
        has_services: true,
        page_size: 50,
        id: _.uniq(pointsId)
      }
      const load = async (page) => {
        return axios.get('catalog/point', {
          params: {page: page, ...params},
          paramsSerializer: function (params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
          },
        })
          .then(res => {
            const data = res.data;
            if (data) {
              if (data.results && data.results.length > 0) {
                points = points.concat(data.results);
              }
              if (data.pagination && data.pagination.next) {
                return load(data.pagination.next);
              }
            }
          });
      };

      await load(1);
    }

    this.setState({
      loadingPoints: false,
      points: points
    });
  };

  searchItems = (items, phrase) => {
    if (!phrase)
      return items;

    const options = {
      includeScore: true,
      threshold: 0.3,
      shouldSort: false,
      keys: [
        'name',
        'address'
      ]
    };

    const fuse = new Fuse(items, options);
    let results = [];
    fuse.search(phrase).forEach(el => results.push(el.item));
    return results;
  };

  handleSearchPoints = (value) => {
    this.setState({
      search: value
    });
  }

  handlePointAdd = (point) => {
    let points = this.state.points;
    const isPointExists = points.filter(item => item.id === point.id).length > 0;
    if (!isPointExists) {
      points.unshift(point);
      this.setState({
        points: points
      })
    }
  }

  render() {
    const { points, search, loadingPoints } = this.state;
    return (
      <FormContext.Consumer>
        {context => {
          const { item, loading } = context;
          return (
            <FormGroup>

              <ContextWidget
                name={'name'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Название',
                  required: true
                }}
              />

              <ContextFormControlWidget
                label={'Перевозчик'}
                name={'carrier'}
                required={true}
                WidgetComponent={AsyncSelectWidget}
                widgetProps={{
                  label: 'Перевозчик',
                  url: 'catalog/choice/?type=CARRIER',
                  required: true
                }}
              />

              <ContextFormControlWidget
                name={'vat'}
                label={'НДС'}
                WidgetComponent={VatWidget}
                widgetProps={{
                  label: 'НДС'
                }}
              />

              <div>
                <FormControl className={'mb-5'}>
                  <CheckboxWidget
                    value={item.as_default}
                    onChange={(value) => context.setValue('as_default', value)}
                    label={'Тариф по умолчанию'}
                  />
                </FormControl>
              </div>

              <div>
                <FormControl>
                  <CheckboxWidget
                    value={item.is_active}
                    onChange={(value) => context.setValue('is_active', value)}
                    label={'Активность'}
                  />
                  <FormHelperText>При снятии галочки попадает в архив</FormHelperText>
                </FormControl>
              </div>

              <div className={'mb-40'}>
                <TariffServicesForm />
              </div>

              {item.id && (
                <div className={'mb-40'}>
                  <YellowButton
                    onClick={(e) => context.handleSubmit(e)}
                    disabled={loading}
                    size={'large'}
                  >
                    Обновить тариф
                  </YellowButton>
                </div>
              )}

              <h2>Точки {points.length}</h2>

              {loadingPoints && (
                <CircularProgress />
              )}

              {!loadingPoints && (
                <React.Fragment>

                  <div className={'mb-20'}>
                    <AddPointDrawer onPointAdd={this.handlePointAdd} points={points} />
                  </div>

                  {points.length > 10 && (
                    <div>
                      <TextField
                        variant={'outlined'}
                        value={search}
                        fullWidth={true}
                        autoFocus={true}
                        placeholder={'Поиск по текущим точкам'}
                        onChange={(e) => this.handleSearchPoints(e.target.value)}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={() => this.setState({search: ''})} disabled={search === ''}>
                                <ClearIcon />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                    </div>
                  )}

                  {this.searchItems(points, search).map((point, index) =>
                    <TariffPointForm
                      key={point.id}
                      point={point}
                      index={index}
                      context={context}
                    />
                  )}
                </React.Fragment>
              )}

            </FormGroup>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
